<template>
  <div class="rate">
    <span>{{text}}</span>
    <div class="star self-center ml-2 mr-4">
      <div :class="['percent', percent_rate]">
      </div>
    </div>
    <div>{{number_percent}} %</div>
  </div>
</template>

<script>
export default {
  name: 'Rate-Results',
  props: ['text', 'percent_rate', 'number_percent']
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";

.rate {
  @apply flex;
  .percent{
    background-color: #F6A82C;
    width: 150px;
    height: 9px;
    border-radius: 10px;
  }
  .star {
    width: 150px;
    height: 11px;
    border: 1px solid #DCDEE0;
    border-radius: 10px;

    .percent-20{
      @apply w-1/5;
    }
    .percent-40{
      @apply w-2/5;
    }
    .percent-60{
      @apply w-3/5;
    }
    .percent-80{
      @apply w-4/5;
    }
    .percent-100{
      @apply w-full;
    }
  }
}
</style>